import { withResultContainer } from '@bingads-webui-react/hoc-with-multi-selector-result-container';
import { withDropdownMenu } from '@bingads-webui-react/hoc-with-dropdown-menu';
import { withMultiAccountListSelector } from './account-selector';

import { OriginCampaignSelector } from './origin-campaign-selector';

export const SingleCampaignSelectorwWthDropdownMenu = withDropdownMenu(OriginCampaignSelector);
export const MultiCampaignSelectorWthDropdownMenu =
  withDropdownMenu(withResultContainer(OriginCampaignSelector));
export const SingleCampaignSelector = OriginCampaignSelector;
export const MultiCampaignSelector =
  withResultContainer(OriginCampaignSelector);

export const AccountCampaignSelector = withDropdownMenu(withResultContainer(withMultiAccountListSelector(OriginCampaignSelector)));
